import Money from "../../../lib/Money";
import React from "react";
import {camelizeKeys} from "../../../ReduxStore/Helpers/transformObject";

export default function CartDisplayShippingTotal(props) {
  let { label, value, shippingAddress={} } = props;

  shippingAddress = camelizeKeys(shippingAddress);

  let stateName = shippingAddress?.stateName;

  // savings line is optional, suppress when zero
  if (!value && props.optional)
    return null;

  // Alaska Shipping, Hawaii Shipping
  if (stateName && (+value > 0)) {
    label = stateName + " Shipping"
  }

  let id = "summary-" + props.id;
  return <div className="grid grid-cols-2 py-1" id={id}>
    <div className="">{label}:</div>
    <div className="text-right">
      {new Money(value || 0).toString()}
    </div>
  </div>
}
